var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 3.9375C6.25 3.02344 6.98828 2.25 7.9375 2.25H13.5625C14.4766 2.25 15.25 3.02344 15.25 3.9375H6.25ZM6.8125 5.0625H14.6875C16.2344 5.0625 17.5 6.32812 17.5 7.875V14.625C17.5 16.207 16.2344 17.4375 14.6875 17.4375H6.8125C5.23047 17.4375 4 16.207 4 14.625V7.875C4 6.32812 5.23047 5.0625 6.8125 5.0625ZM11.5938 7.875C11.5938 7.41797 11.207 7.03125 10.75 7.03125C10.2578 7.03125 9.90625 7.41797 9.90625 7.875V11.25C9.90625 11.4961 9.97656 11.707 10.1523 11.8477L11.8398 13.5352C12.1562 13.8867 12.6836 13.8867 13.0352 13.5352C13.3516 13.2188 13.3516 12.6914 13.0352 12.375L11.5938 10.9336V7.875ZM7.9375 20.25C6.98828 20.25 6.25 19.5117 6.25 18.5625H15.25C15.25 19.5117 14.4766 20.25 13.5625 20.25H7.9375Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default ForwardRef;